module.exports = __webpack_public_path__ + "img/pab.61e43a90.svg";